/**
 * @generated SignedSource<<253b21fd3a47cfd55429dc8bbae5ff30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceIntegrationConfluenceOauthUrlQuery$variables = Record<PropertyKey, never>;
export type ConfluenceIntegrationConfluenceOauthUrlQuery$data = {
  readonly confluenceOauthUrl: {
    readonly oauthUrl: string;
  };
};
export type ConfluenceIntegrationConfluenceOauthUrlQuery = {
  response: ConfluenceIntegrationConfluenceOauthUrlQuery$data;
  variables: ConfluenceIntegrationConfluenceOauthUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConfluenceOauthUrlPayload",
    "kind": "LinkedField",
    "name": "confluenceOauthUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oauthUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfluenceIntegrationConfluenceOauthUrlQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ConfluenceIntegrationConfluenceOauthUrlQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e5a1f8b89a8fc150eb0b8c8d564ebda5",
    "id": null,
    "metadata": {},
    "name": "ConfluenceIntegrationConfluenceOauthUrlQuery",
    "operationKind": "query",
    "text": "query ConfluenceIntegrationConfluenceOauthUrlQuery {\n  confluenceOauthUrl {\n    oauthUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e4ac82044ed734cd4f1c1fb04bca4ed";

export default node;
